<template>
  <div class="scaffold">
    <div class="content-small">
      <div class="logo">
        <AEyeLogo />
      </div>
      <div class="text">
        Please use a larger device (from tablet to desktop) to fully enjoy our Creative Lift experience!
      </div>
    </div>
    <div class="wrapper content-large">
      <div class="header">
        <div class="logo">
          <AEyeLogo />
        </div>
        <div class="identity" v-if="identity">
          <Identity />
        </div>
      </div>
      <div class="body">
        <div class="content" :class="{ 'content-with-topbar': hasTopbar }">
          <div class="menu" v-if="user && showMenu">
            <ts-menu>
              <div class="inner-menu">
                <Menu :show-project-menu="showProjectMenu" />
              </div>
            </ts-menu>
          </div>
          <ts-page class="page">
            <slot name="toolbar"></slot>
            <div class="page-content" :class="{ 'page-content-with-topbar': hasTopbar }">
              <ts-loader v-if="loading" class="loader"></ts-loader>
              <slot></slot>
            </div>
            <slot name="bottombar"></slot>
            <div v-if="showOverlay" class="page-overlay">
              <slot name="overlay"></slot>
            </div>
            <download-succes-dialog></download-succes-dialog>
            <download-pending-alert></download-pending-alert>
          </ts-page>
        </div>
        <div v-if="hasTopbar" class="topbar">
          <slot name="topbar"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.scaffold {
  height: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  max-width: 1300px;
}

.content-small {
  display: none;
}

@media screen and (max-width: 1024px) {
  .content-small {
    display: flex;
    flex-direction: column;
    height: 100vh;
    align-items: center;
    justify-content: center;

    .text {
      color: #6d7587;
      text-align: center;
      margin: 20px 20px 0 20px;
    }
  }
  .content-large {
    display: none !important;
  }
}

.wrapper {
  max-width: 1300px;
  height: 100%;
  display: flex;
  flex-direction: column;

  .header {
    height: 80px;
    padding-top: 10px;
    display: flex;
    justify-content: space-between;

    .logo {
      display: flex;
      position: relative;
      width: 183px;
      align-items: center;
      justify-content: center;
    }
    .beta{
      position: absolute;
      font-size: .7rem;
      display: inline-block;
      padding: 2px 4px;
      border-radius: 4px;
      background: #09AF81;
      right: 0;
      color: white;
      text-transform: capitalize;
      top: 0;
      margin-left: 50px;
    }
  }

  .loader {
    position: absolute;
    height: 100%;
    width: 100%;
    background-color: rgba(235, 236, 240, 0.8);
  }

  .body {
    display: flex;
    flex-direction: column-reverse;
  }

  .topbar {
    height: 76px;
    border-radius: 38px;
    background: #ebecf0;
    box-shadow: 6px 6px 16px 0 rgba(166, 171, 189, 0.4), -6px -6px 16px 0 rgba(250, 251, 255, 0.4);
    border: solid 2px rgba(255, 255, 255, 0.32);
    background-blend-mode: soft-light, normal;
    background-image: linear-gradient(274deg, #000000, var(--fills-neutral-white) 0%),
      linear-gradient(to bottom, #ebecf0, #ebecf0);
    position: relative;
  }

  .content {
    display: flex;
    height: calc(100vh - 80px - 10px);
    position: relative;

    .menu {
      flex-shrink: 0;
      width: 183px;
      margin-right: 15px;

      .inner-menu {
        margin: -2px;
      }
    }

    .page {
      flex-grow: 1;
      position: relative;

      .account-selector {
        position: absolute;
        right: -95px;
        top: 45px;
        z-index: 0;
      }

      .page-content {
        height: 100%;
        display: flex;
        flex-direction: column;
        overflow-y: auto;
        .page-container {
          flex: auto;
        }
      }

      .page-content-with-topbar {
        padding-top: 38px;
      }

      .page-overlay {
        background-color: rgba(235, 236, 240, 0.6);
        transition: background-color 0.5s;
        border-radius: 32px;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        z-index: 2;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }

  .content-with-topbar {
    height: calc(100vh - 80px - 10px - 38px);
    margin-top: -38px;
  }
}
</style>

<script>
import { mapState } from 'vuex';
import AEyeLogo from '@/assets/ai-eye.svg';
import CreativeLiftLogo from '@/assets/creative-lift.svg';
import Identity from './Identity';
import Menu from './Menu';
import DownloadSuccesDialog from '../widgets/DownloadSuccesDialog.vue';
import DownloadPendingAlert from '../widgets/DownloadPendingAlert.vue';
import projectViewHelpers from '@/mixins/projectViewHelpers';

export default {
  mixins: [projectViewHelpers],
  components: {
    AEyeLogo,
    Identity,
    Menu,
    CreativeLiftLogo,
    DownloadSuccesDialog,
    DownloadPendingAlert
  },
  props: {
    showMenu: {
      type: Boolean,
      default: true
    },
    identity: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    showOverlay: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showAccountSelector: false,
      showProjectMenu: false
    };
  },
  computed: {
    ...mapState({
      user: state => state.identity.user
    }),
    hasTopbar() {
      return !!this.$slots.topbar;
    }
  },
  mounted() {
    this.showAccountSelector = this.$router?.currentRoute?.meta?.showAccountSelector;
    this.showProjectMenu = this.$router?.currentRoute?.matched?.some(route => route.meta.showProjectMenu);
  }
};
</script>
